
export default {
  name: "LotterySectionTitle",
  props: {
    title: {
      type: String,
      default: "",
    },
  },
};
